/* eslint-disable react/no-array-index-key */
/* eslint-disable security/detect-object-injection */
/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react';
import Sidebar from 'components/sidebar';
import BackgroundWrapper from 'components/Background';
import { useAppDispatch, useAppSelector } from "hooks/store-hooks";
import Loading from 'components/Loading';
import { updateUserConfigResponse, getUserChatHistoryResponse, getUserConversationSummaryResponse } from 'constants/common';
import { DEFAULT_DOMAIN } from 'constants/constant';
import { useNavigate, useParams } from 'react-router-dom';
import { setInsightsToShow, setConversationHistory, setConversationSummary } from 'store/slice/conversationSlice';
import { setOutletLoading, setShowInsightsOnUi, setUserChatDetails, setActiveChatId } from 'store/slice/userSlice';
import home from 'assets/images/home.png';
import Conversation from './Conversation';
import ChatInput from './ChatInput';

function Home() {
  const scrollEndRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const { outletLoading, user_id, userType, selectedDomain } = useAppSelector((state) => state.user);
  const { chatId } = useParams();
  const [url, setUrl] = useState("http://4.187.216.183/d/adbp9zt/new-dashboard?orgId=1&kiosk");
  const scrollToBottom = () => {
    if (scrollEndRef.current) {
      const scrollContainer = scrollEndRef.current;
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  };

  const chatInitiationApi = async () => {
    const payload: any =
    {
      username: user_id,
      domain_name: selectedDomain || DEFAULT_DOMAIN,
      call_conversation: true,
      call_ipro:false,
      call_kb: false,
      call_rag: false,
      call_web_search: false,
      theme: 'light',
      language: 'english',
      update_config: false,
    }
    dispatch(setOutletLoading(true));
    dispatch(setInsightsToShow({}))
    dispatch(setShowInsightsOnUi(false))
    const response = await updateUserConfigResponse(payload);
    dispatch(setUserChatDetails(response.data));
    localStorage.setItem('convMode', response.data.call_conversation)
    localStorage.setItem('kbMode', response.data.call_kb)
    localStorage.setItem('ragMode', response.data.call_rag)
    localStorage.setItem('webSearchMode', response.data.call_web_search)
    localStorage.setItem('theme', JSON.stringify(response.data.theme))
    localStorage.setItem('language', JSON.stringify(response.data.language.toLowerCase()))
    localStorage.setItem('call_ipro', response.data.call_ipro)
    dispatch(setActiveChatId(!chatId ? 'new' : chatId))

    const historyPayload: any = {
      chat_id: !chatId ? 'new' : chatId
    }

    const responseHistory = await getUserChatHistoryResponse(historyPayload);
    if (responseHistory.data.history !== undefined) {
      dispatch(setConversationHistory(responseHistory.data.history))
    }
    else {
      dispatch(setConversationHistory([]))
    }

    dispatch(setOutletLoading(false));

    const conversationSummaryPayload: any = {
      username: user_id,
      domain_name: response.data?.domain_name?.trim?.().toLowerCase().replace(/\s+/g, '_') || DEFAULT_DOMAIN,
    }

    const summaryResponse = await getUserConversationSummaryResponse(conversationSummaryPayload);
    if (summaryResponse.data.conversation.length > 0) {
      dispatch(setConversationSummary(summaryResponse.data.conversation))
    } else {
      dispatch(setConversationSummary([]))
    }

    navigate(`/threads/${!chatId?'new':chatId}`);


  }



  useEffect(() => {
    // chatInitiationApi();
  }, [])

  return (
    <BackgroundWrapper>
      <div className="flex flex-1 flex-col lg:flex-row h-[64px]">
       <img src={home} alt='coming soon' className='m-auto' />
      </div>
      <div
      role="status"
      aria-live="polite"
      className="absolute inset-0 z-40 flex flex-col items-center justify-center gap-4 dark:bg-black/50 rounded-lg p-4 backdrop-blur-[6px]"   
    >
      <div className="flex items-center gap-3">
        <span className="text-[18px]  font-bold text-[#27303A] dark:text-gray-100">Coming soon...</span>
      </div>
      </div>
    </BackgroundWrapper>
  )
}

export default Home
